import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import PageLayout from "@components/layouts/PageLayout";
import BasicButton from "@components/buttons/BasicButton";
import { HOME_ROUTE } from "@utils/Routes";
import parse from "html-react-parser";

const TermsOfUseScreen: FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const categories = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ];

  return (
    <PageLayout
      noHeader
      title={t("terms-of-use.title")}
      noContentInCard={false}
      bodyClassName="PublicPage"
      noFooter
    >
      <>
        <div>
          {/*{parse(t("terms-of-use.body"))}*/}
          {categories.map((category) => (
            <>
              <h3 className="mt-5">
                {parse(t("terms-of-use.categories.title" + category))}
              </h3>
              <span>{parse(t("terms-of-use.categories.body" + category))}</span>
            </>
          ))}
        </div>

        <p className="d-flex align-items-center justify-content-center flex-wrap">
          <BasicButton
            text={t("buttons.back")}
            variant="tertiary"
            className="mt-4 me-2"
            onClick={() => history.push(HOME_ROUTE)}
          />
        </p>
      </>
    </PageLayout>
  );
};

export default TermsOfUseScreen;
